var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 53",
    "data-testid": "iDEAL-logo",
    title: "iDEAL logo",
    style: {
      width: 45,
      height: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 3.9v44.815c0 2.145 1.764 3.9 3.92 3.9h26.913C51.18 52.615 60 41.285 60 26.25 60 11.291 51.18 0 30.833 0H3.92C1.764 0 0 1.755 0 3.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C06",
    d: "M18.014 10.999v33.113h14.485c13.153 0 18.857-7.39 18.857-17.844 0-10.004-5.704-17.766-18.857-17.766H20.523A2.507 2.507 0 0 0 18.013 11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.429 49.047h23.404c16.445 0 25.52-8.094 25.52-22.778 0-8.464-3.312-22.68-25.52-22.68H7.429c-2.078 0-3.764 1.676-3.764 3.744v37.97c0 2.066 1.686 3.744 3.764 3.744M4.919 7.333a2.495 2.495 0 0 1 2.509-2.497h23.404c9.056 0 24.266 2.79 24.266 21.433 0 13.885-8.624 21.53-24.266 21.53H7.428a2.495 2.495 0 0 1-2.51-2.497z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.142 21.456a4.1 4.1 0 0 0-1.4-.236v-.02h-3.317V29.2h3.356c.594 0 1.112-.119 1.553-.316a3.2 3.2 0 0 0 1.093-.847c.287-.354.498-.788.652-1.28.134-.493.21-1.025.21-1.616 0-.67-.095-1.24-.268-1.733a4 4 0 0 0-.748-1.222 3.1 3.1 0 0 0-1.13-.729m-.787 6.167c-.25.079-.48.118-.729.118v.02h-1.514v-5.044h1.227c.422 0 .767.06 1.054.178s.518.315.69.532c.173.216.307.512.384.827s.115.69.115 1.084c0 .453-.058.807-.172 1.123a2.3 2.3 0 0 1-.442.748 1.4 1.4 0 0 1-.613.414",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.211 21.22v1.477h-4.103v1.714h3.777v1.36h-3.777v1.95h4.199V29.2H28.4V21.2h5.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m42.993 29.218-2.915-7.998h-1.783l-2.934 7.998h1.726l.613-1.773h2.915l.594 1.773zm-3.797-6.028.978 2.935h-2.013l1.016-2.935z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.773 21.22v6.52h3.796v1.478h-5.503V21.22z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.283,
    cy: 25.575,
    r: 3.761,
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.521 44.38c-2.91 0-5.247-2.514-5.247-5.602v-4.374c0-1.544 1.168-2.811 2.633-2.811 1.446 0 2.633 1.247 2.633 2.81v9.977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.cc8e97826b57d6b6cbdf9fea4610a253.svg";
export { ForwardRef as ReactComponent };